import { Component, OnInit, Input, HostListener } from '@angular/core';

@Component({
    selector: 'viega-icon-button',
    templateUrl: './viega-icon-button.component.html',
    styleUrls: ['./viega-icon-button.component.scss'],
})
export class ViegaIconButtonComponent {
    public matColor: string = "basic";

    @Input()
    public icon: string = "right_thin-01";

    @Input()
    public background: string;

    @HostListener("mousedown", ["$event"])
    private onMouseDown(event: any) {
        // prevent this button from being focused after click
        event.preventDefault();
    }
}



// WEBPACK FOOTER //
// ./src/viega-common/components/viega-icon-button/viega-icon-button.component.ts